"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef } from "react";
import { useIsomorphicLayoutEffect } from "./useIsomorphicLayoutEffect";
export function useEventCallback<Args extends unknown[], R>(fn: (...args: Args) => R): (...args: Args) => R;
export function useEventCallback<Args extends unknown[], R>(fn: ((...args: Args) => R) | undefined): ((...args: Args) => R) | undefined;
export function useEventCallback(fn) {
  const $ = _c(4);
  const ref = useRef(_temp);
  let t0;
  let t1;
  if ($[0] !== fn) {
    t0 = () => {
      ref.current = fn;
    };
    t1 = [fn];
    $[0] = fn;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useIsomorphicLayoutEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = (...t3) => {
      const args = t3;
      return ref.current?.(...args);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2 as (...args: Args) => R;
}
function _temp() {
  throw new Error("Cannot call an event handler while rendering.");
}